import img1 from "../../../../assets/images/academy/s1.webp";
import img2 from "../../../../assets/images/academy/s2.webp";
import img3 from "../../../../assets/images/academy/s3.webp";
import img4 from "../../../../assets/images/academy/s4.webp";
import img5 from "../../../../assets/images/academy/s5.webp";

export const COURSE_IMAGES = [img1, img2, img3, img4, img5];
